<app-banner 
    [titulo]="bannerTitulo"
    [descripcion]="bannerContenido"
    [margen]="bannerMargen"
    [imageUrl]="bannerImagen">
</app-banner>
<app-carrusel></app-carrusel>
